// @flow
import Final from "./Final";
import NewFinal from "./NewFinal";
import Start from "./Start";

export default Final;
export { Start as StartPopup, NewFinal as NewFinalPopup };



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/index.js